module.exports = __webpack_public_path__ + "img/betsize_btn.32077338.png";